export { default as ic_success } from "./ic_success.svg?react";
export { default as ic_warning } from "./ic_warning.svg?react";
